<template>
  <section class="section mobile_div section_bg container-fluid first_page content_background_color_blue2   pb-5" >
    <div class="section_header  d-flex justify-content-center" v-if="is_load">
    <nav aria-label="breadcrumb" v-if="is_load">
      <ol class="breadcrumb">

        <li class="breadcrumb-item"><router-link tag="a" :to="'/project/'+project.last_id" >{{ project.name_project}}</router-link></li>
        <li class="breadcrumb-item"><router-link tag="a" :to="'/project/'+project.last_id+'/articles'" >База знаний</router-link></li>
        <li class="breadcrumb-item" v-if="post_data.parent"><router-link  :to="{name: 'one_article', params: {id:project.last_id, post_id: post_data.parent.last_id }}"
        >{{post_data.parent.title}}
        </router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ post_data.title}}</li>
      </ol>
    </nav>
    </div>
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <div class="container loading_div" v-if="is_load==false">
      <h2>{{ load_message }}</h2>
    </div>
    <div class="row" v-if="is_load">
      <div class="col-lg-8 col-md-8 col-12">
        <div class="section_header">
          <!-- shape Hero -->

          <!-- 1st Hero Variation -->
          <div class="row d-flex justify-content-center"   >

            <router-link tag="a" class="btn btn-sm" :to="{name: 'add_article',params:{'id':project.last_id,'parent_id':post_data.last_id}}">
              Новая статья
            </router-link>


          </div>
        </div>
        <div>

          <div class="post_material_mini section_header nocenter">
            <div class="no_spaces_for_div col-12 col-md-10 col-lg-10">
              <UserCard :user="post_data.user"/>
            </div>


            <div class="post_material_mini_content">
              <editorjsrender   :blocks_json="post_data.content.blocks" ref="contentArticle"></editorjsrender>
            </div>
            <div class="d-flex justify-content-between post_material_mini_bottom">
              <p><i class="fa fa-calendar-o"></i><small>&nbsp; {{ post_data.created_at }}</small></p>

            </div>


           <button class="btn mt-2" @click="exportPDF()"><i class="fa fa-file-pdf-o"></i></button>

            <router-link tag="a" class="btn mt-2" :to="{name: 'edit_article', params: { id:project.last_id,post: post_data.last_id }}">
              Редактировать
            </router-link>
          </div>


          <div class="">





            <div   style="padding:0px;"
                  v-for="post in posts"
                  :key="post.last_id">
              <div class="section_header nocenter mt-2 mb-2 post_material_mini">





                <div class="post_material_mini_content" @click="openArticle(post.last_id,project.last_id)">
                  <div>
                    <div><h2>{{ post.title}}</h2></div>

                  </div>
                </div>
                <div class="d-flex justify-content-between post_material_mini_bottom">
                  <p><i class="fa fa-calendar-o"></i><small>&nbsp; {{ post.created_at }}</small></p>

                </div>


                <router-link class="btn "  :to="{name: 'one_article', params: {id:project.last_id, post_id: post.last_id }}"
                >
                  Читать далее
                </router-link>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4  ">
        <card class="section_header nocenter">
          <div class="row form-group">
            <p>Поиск по базе знаний</p>
          </div>
          <div class="row form-group">
            <input type="text" class="form-control" v-model="search_string" placeholder="Введите название"/>
          </div>
          <div class="row form-group">
            <button class="btn" @click="searchArticles">Найти</button>
          </div>

          <ul class="nav navbar multi_struct"  >

            <li>
              <router-link tag="a"  :to="{name: 'add_article',params:{'id':project.last_id}}">
              &#x1F4C4;  Новая статья
              </router-link>
            </li>
            <treeview v-if="all_posts.length>0" v-for="article in all_posts" :key="article.last_id"   class="item"
                      :item="article" :current="post_data.last_id"

                      @add-item="addArticle"></treeview>







          </ul>
        </card>
      </div>
    </div>
  </section>

</template>

<script>
import Api from "@/models/Api";
import Vue from "vue";
import Editorjsrender from "@/models/Editorjsrender";
import {eventBus} from "@/main";
import TreeView from "../../../components/TreeView";
import UserCard from "@/components/Custom/UserCard";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import FileSaver from 'file-saver';
import ExportModel from "@/models/ExportModel";
export default {
  name: "ArticlesOne",
  data() {
    return {
      load_message:"Идет загрузка...",
      is_load: false,
      post_data: null,
      image_url: null,
      background_header: "/img/header_bg.jpg",
      user: null,
      islogin: false,
      "new_comment_is_error": false,
      "new_comment_error": null,
      post_subcomment: [],
      "newComment": {
        "comment": null
      },
      'dissable_comment':true,
      'project':null,
      'all_posts':[],
      'posts':[],
      search_string:'',

    }
  },
  mounted() {
    //AppHeader.methods["testLog"]();


    var app = this;
    app.image_url = Vue.config.IMAGE_URL;
    let id = app.$route.params.id;
    let post_id = app.$route.params.post_id;

    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });
    app.loadArticle();

  },
  methods: {

    openArticle(post_id,project_id){
      var app=this;
      app.$router.push({name: 'one_article', params: {id:project_id, post_id: post_id }});
    },
    async  exportPDF(){


      var app=this;
      var vm=this;
     var title=app.post_data.title;


      var htmlData=app.$refs.contentArticle.$el.innerHTML;
      var footerHTML="<p>Статья <a href='"+document.location.href+"'>"+title+"</a></p>"

      await ExportModel.start(title,htmlData,footerHTML);

    },

    searchArticles(){
      var app = this;
      let id = app.$route.params.id;
      app.is_load=false;


      Api.loadProjectArticlesList(id,app.search_string,20, 0, function (data) {

        //   app.count = data.count;
        //  app.posts=[];
        // app.posts = app.posts.concat(data.posts);
        app.all_posts=data.all_posts;


        //  app.current = app.current + data.posts.length;

        //  app.project=data.project;

        app.is_load=true;

        //  app.background_header = app.image_url + data.category.background;


      })
    },
    setLoad(message="Идет загрузка"){
      var app=this;

      app.load_message=message;
      app.is_load=false;
    },
    disableLoad(){
      var app=this;

      app.load_message="Идет загрузка";
      app.is_load=true;
    },
    loadArticle(){
      var app=this;
      let id = app.$route.params.id;
      let post_id = app.$route.params.post_id;
      var searchString=app.search_string;
      Api.loadArticleOne(id,post_id,searchString, function (data) {
        app.post_data = data.post;
        app.project=data.project;
        app.all_posts=data.all_posts
        app.posts=data.posts;


        app.is_load = true;
      })
    },
    addArticle(item){
      var app=this;
      app.$router.push({name: 'add_article',params: {id: app.project.last_id, "parent_id":item.last_id}});
    },
    deleteArticle(){
      var app=this;
      var post_id=app.post_data.last_id;
      var project_id=app.project.last_id;
      Api.deleteArticleinProject(project_id,post_id,function(data){
        app.$router.push({name: 'list_articles',params: {id: app.project.last_id}});
      })
    },
    openProject( ){
      var app=this;


      let routeData = app.$router.resolve({name: 'project',params: {id: app.project.last_id, "rand": Math.random()}});
      window.open(routeData.href, '_self');
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },
    toogleEnable() {
      var app = this;
      Api.changeEnablePost(app.post_data.last_id, function (data) {
        app.post_data = data;
      })
    },
    deleteComment(comment_id, index_comment) {
      var app = this;
      Api.deleteCommentPost(comment_id, app.post_data.last_id, function (data) {
        //   app.post_data.comments = app.post_data.comments.slice();
        //
        app.post_data.comments.splice(index_comment, 1);
      })
    },
    deleteSubComment(subcomment_id, comment_id, index_sub, index_comment) {
      var app = this;
      Api.deleteSubCommentPost(subcomment_id, comment_id, app.post_data.last_id, function (data) {
        //   app.post_data.comments = app.post_data.comments.slice();
        //
        app.post_data.comments[index_comment].comments.splice(index_sub, 1);
      })
    },
    sendSubComment(comment_id, comment_index) {
      var app = this;

      var comment = app.post_subcomment['comment' + comment_id];
      Api.sendPostSubComment(app.post_data.last_id, comment_id, comment, function (comments) {
        app.post_data.comments[comment_index].comments = comments;
        app.post_subcomment['comment' + comment_id] = "";
      });
    },
    sendComment(event) {
      event.preventDefault();
      var app = this;
      var newComment = app.newComment;
      Api.addPostComment(newComment, app.post_data.last_id, function (result_comment) {
        app.iserror = false;

        app.newComment.comment = "";
        app.post_data.comments.push(result_comment)
      }, function (message) {
        app.iserror = true;
        app.error_message = message;
      })


    },
    callEditPost() {
      var app = this;
      var params = {

        type: "post_edit",
        post_id: app.post_data.last_id,
        modal_title: "Редактировать пост",

        blog_category_default:app.post_data.category_post.last_id,
        blog_category_row:app.post_data.category_post,
        category: app.post_data.category,
        category_post: app.post_data.category_post,
        json: app.post_data.content
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    }
  },
  components: {
    'editorjsrender': Editorjsrender,
    'treeview':TreeView,
    'UserCard':UserCard,
    LoadingBlock
  }
}
</script>

<style scoped>

</style>